<template>
        <div class="warp">
        <breadcrumb :back="true" :crubList="[{name:'用户管理'},{name:'用户列表',goback:true},{name:'新增用户'}]" :title="'新增用户'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>账号：</div>
                        <div class="content">
                            <el-input v-model="acontInfo.userName"  @blur="acontRepeat" maxlength="20"
                                      placeholder="6-20位数字,字母和下划线"></el-input>
                            <div class="error" v-if="repet">【该账号已重复】，不可完成新建</div>
                            <div class="error" v-if="errors['acontInfo.userName']">
                                错误提示：{{errors['acontInfo.userName']}}
                            </div>
                        </div>
                    </div>
                    <div class="child">
                        <div class="name"><span>*</span>企业名称：</div>
                        <div class="content">
                            <el-input v-model="acontInfo.companyName" maxlength="20"
                                      placeholder="请输入企业全称"></el-input>
                            <div class="error" v-if="errors['acontInfo.companyName']">
                                错误提示：{{errors['acontInfo.companyName']}}
                            </div>
                        </div>
                    </div>
                    <div class="child">
                        <div class="name"><span>*</span>统一社会信用代码：</div>
                        <div class="content">
                            <el-input v-model="acontInfo.companyNum" maxlength="18"
                                      placeholder="请输入统一社会信用代码"></el-input>
                            <div class="error" v-if="errors['acontInfo.companyNum']">
                                错误提示：{{errors['acontInfo.companyNum']}}
                            </div>
                        </div>
                    </div>

                    <div class="child mt10">
                        <div class="name">初始密码：</div>
                        <div class="content">初始密码与账号相同</div>
                    </div>
                    
                    <div class="child" style="align-items:flex-start">
                        <div class="name"><span>*</span>用户类型：</div>
                        <div class="content">
                            <el-radio-group v-model="acontInfo.userType" @change="changeUserType">
                                <div v-if="userTypeAdd.length>0">
                                    <el-radio style="margin-bottom: 10px;" :label="item.value"
                                              v-for="(item,index) in userTypeAdd" :key="index">{{item.name}}
                                    </el-radio>
                                </div>
                            </el-radio-group>
                            <div class="error" v-if="errors['acontInfo.userType']">*{{errors['acontInfo.userType']}}
                            </div>
                        </div>
                    </div>
                    <div class="child" v-if="acontInfo.userType">
                        <div class="name"><span>*</span>联系人：</div>
                        <div class="content">
                            <el-input v-model="acontInfo.contact" maxlength="20"></el-input>
                            <div class="error" v-if="errors['acontInfo.contact']">*联系人错误</div>
                        </div>
                    </div>

                    <div class="child" v-if="acontInfo.userType">
                        <div class="name"><span>*</span>联系电话：</div>
                        <div class="content">
                            <el-input v-model="acontInfo.contactPhone" maxlength="11"></el-input>
                            <div class="error" v-if="errors['acontInfo.contactPhone']">*联系电话错误</div>
                        </div>
                    </div>
                    <!-- v-if="acontInfo.userType =='INSTITUTIONAL_INVESTOR'" -->
                    <div class="child"
                         v-if="acontInfo.userType=='CORPORATE_CLIENTS' || acontInfo.userType=='INSTITUTIONAL_INVESTOR'  || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='GUARANTEE_COMPANY'">
                        <div class="name"><span>*</span>{{acontInfo.userType=='INSTITUTIONAL_INVESTOR'?'上传名片':'营业执照'}}：
                        </div>
                        <div class="content">
                            <upLoad
                                    :action="'backstage/annex/file'"
                                    :size="acontInfo.userType=='INSTITUTIONAL_INVESTOR' || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='BANK' || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='GUARANTEE_COMPANY'?1:5"
                                    :number="1"
                                    :accept="'image/png,image/jpg'"
                                    v-model="acontInfo.attachmentUrl"/>
                            <div class="error" v-if="acontInfo.userType !=='INSTITUTIONAL_INVESTOR' && errors['acontInfo.attachmentUrl']">
                                *{{errors['acontInfo.attachmentUrl']}}{{acontInfo.userType=='INSTITUTIONAL_INVESTOR'?'名片':'营业执照'}}
                            </div>
                        </div>
                    </div>
                    <div class="child" v-if="acontInfo.userType=='CORPORATE_CLIENTS' || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='GUARANTEE_COMPANY'">
                        <div class="name"></div>
                        <div class="content">
                            <div class="hint">*png、jpg等常规格式图片，大小不超过5M</div>
                        </div>
                    </div>

                    <div class="child" v-if="acontInfo.userType=='FINANCE_LEASING_COMPANY'">
                        <div class="name"><span>*</span>分类:</div>
                        <div class="content">
                            <el-select v-model="acontInfo.classify" placeholder="请选择">
                                <el-option
                                        v-for="(item,index) in classifyList"
                                        :key="index"
                                        :label="item.dictName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <div class="error" v-if="errors['acontInfo.classify']">*{{errors['acontInfo.classify']}}
                            </div>
                        </div>
                    </div>
                    <div class="child"
                         v-if="acontInfo.userType=='BANK' || acontInfo.userType=='GUARANTEE_COMPANY' || acontInfo.userType=='FINANCE_LEASING_COMPANY'">
                        <div class="name"><span>*</span>LOGO:</div>
                        <div class="content">
                            <upLoad
                                    :action="'backstage/annex/file'"
                                    :size="20"
                                    :limit="1"
                                    :accept="'image/png,image/jpg'"
                                    v-model="acontInfo.logoUrl"/>
                            <div class="error" v-if="errors['acontInfo.logoUrl']">*{{errors['acontInfo.logoUrl']}}</div>
                        </div>
                    </div>
                    <div class="child"
                         v-if="acontInfo.userType=='INSTITUTIONAL_INVESTOR' || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='BANK' || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='GUARANTEE_COMPANY'">
                        <div class="name"></div>
                        <div class="content">
                            <div class="hint">*png、jpg等常规格式图片，大小不超过1M</div>
                        </div>
                    </div>

                    <div class="child" v-if="acontInfo.userType=='BANK'">
                        <div class="name"><span>*</span>银行名称（简称）:</div>
                        <div class="content">
                            <el-input v-model="acontInfo.abbreviation"></el-input>
                            <div class="error" v-if="errors['acontInfo.abbreviation']">
                                *{{errors['acontInfo.abbreviation']}}
                            </div>
                        </div>
                    </div>

                    <div class="child" v-if="acontInfo.userType=='BANK'">
                        <div class="name"><span>*</span>官网链接:</div>
                        <div class="content">
                            <el-input v-model="acontInfo.websiteLink"></el-input>
                            <div class="error" v-if="errors['acontInfo.websiteLink']">
                                *{{errors['acontInfo.websiteLink']}}
                            </div>
                        </div>
                    </div>

                    <div class="child" style="align-items:flex-start"
                         v-if="acontInfo.userType=='BANK' || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='GUARANTEE_COMPANY'">
                        <div class="name"><span>*</span>{{acontInfo.userType=='BANK'?'银行简介':'公司简介'}}:</div>
                        <div class="content remark">
                            <el-input style="width: 300px;" type="textarea" :autosize="{ minRows: 2, maxRows: 6}"
                                      v-model="acontInfo.remarks" show-word-limit maxlength="500"></el-input>
                            <div class="error" v-if="errors['acontInfo.remarks']">*{{errors['acontInfo.remarks']}}</div>
                        </div>
                    </div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                            <div class="hint">说明：新添加的账号为个人客户类型，需在用户前端提交资料完成认证，相关的业务也需在用户前端完成</div>
                        </div>
                    </div>
                    
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                            <div class="doubleBtn">
                                <el-button type="primary" size="small" @click="submitAdd()">确认</el-button>
                                <el-button size="small" @click="cancel">取消</el-button>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../components/upLoads'
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        upLoad
    },
    data(){
        return{
            statusList: [],//服务类型
			id:'',
      act: /^[\w]{6,20}$/,
      xym: /[1-9A-GY]{1}[1239]{1}[0-9]{1}[0-9]{5}[0-9A-Z]{10}/,
           acontInfo: {
                    abbreviation: '',//银行简称
                    attachmentUrl: '',//上传图片地址(营业执照，名片)（图片地址最大长度100）
                    classify: '',//分类
                    companyName: '',//企业全称
                    companyNum: '',//统一社会信用代码 [1-9A-GY]{1}[1239]{1}[0-9]{1}[0-9]{5}[0-9A-Z]{10}
                    contact: '',//联系人^[\u4e00-\u9fa5]{0,}$
                    contactPhone: '',//联系电话
                    logoUrl: '',//logo地址
                    remarks: '',//银行简介
                    userName: '',//账号(^[\w]{6,20}$)
                    userType: '',//用户类型
                    websiteLink: '',//官网链接
                },
            rules: {
                 sort: [
                    { required: true, message: '请输入序号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                          debugger
                            if (this.$reg.numPint.test(value) == false) {
                                callback(new Error('请输入正整数'))
                            } else {
                                return callback()
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                sourceId:{ required: true, message: '请选择产品名称', trigger: 'change' }
            
            },
             classifyList: [],//分类
                userTypeAdd: [],//用户类型添加用
                repet: false,//账号是否重复
			
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
            'acontInfo.companyName': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '输入企业全称'
            },
            'acontInfo.companyNum': {
                test: function (val) {
                    if (this.xym.test(val)) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '统一社会信用代码格式不正确'
            },
            'acontInfo.userType': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '选择用户类型'
            },
            'acontInfo.contact': 'realName',
            'acontInfo.contactPhone': 'phone',
            'acontInfo.attachmentUrl': {
                test: function (val) {
                    if (val.length > 0) {
                        return true;
                    } else {
                      if(this.acontInfo.userType === 'FINANCE_LEASING_COMPANY' || this.acontInfo.userType === 'CORPORATE_CLIENTS' || this.acontInfo.userType === 'INSTITUTIONAL_INVESTOR' ||  this.acontInfo.userType === 'GUARANTEE_COMPANY')
                        {
                          return false;
                        }else return true
                    }
                },
                message: '上传'
            },
            'acontInfo.classify': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '选择分类'
            },
            'acontInfo.logoUrl': {
                test: function (val) {
                    if (val.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '上传名片或上传LOGO'
            },
            'acontInfo.abbreviation': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                      if(this.acontInfo.userType === 'FINANCE_LEASING_COMPANY') return true
                      else return false;
                    }
                },
                message: "输入银行名称"
            },
            'acontInfo.websiteLink': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                      if(this.acontInfo.userType === 'FINANCE_LEASING_COMPANY') return true
                      else return false;
                    }
                },
                message: "输入官网链接"
            },
            'acontInfo.remarks': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: "输入简介"
            },
            'acontInfo.userName': {
                test: function (val) {
                  
                    if (this.act.test(val)) {
                        return true;
                    } else {
                        this.repet = false
                        return false;
                    }
                },
                message: "【账号格式错误】,不可完成新建"
            },
        },
	created() {
    this.getDic();
    const {id} = this.$route.params
		if(id){
		    this.usId=id;
		}
		
	},
   
    methods:{
      // 账号查重
            acontRepeat() {
                if (this.acontInfo.userName == ''||!this.act.test(this.acontInfo.userName)) {
                    return
                }
                this.$axiosz.get('/backstage/sysUser/manage/userName/' + this.acontInfo.userName).then((r) => {
                    if (r.code == 200) {
                        this.repet = false;
                    } else {
                        this.repet = true;
                        this.$alert(r.msg)
                    }
                })
            },
      //用户类型切换 重置数据
            changeUserType: function () {
                this.acontInfo.attachmentUrl = '';//营业执照
                this.acontInfo.classify = '';//分类
                this.acontInfo.logoUrl = '';//logo地址=
                this.acontInfo.contact = '';//联系人
                this.acontInfo.contactPhone = '';//联系电话
                this.acontInfo.abbreviation = '';//银行简称
                this.acontInfo.websiteLink = '';//官网链接
                this.acontInfo.remarks = '';//银行简介
            },
         //确定按钮
           //保存
            submitAdd: function () {
                const that = this
                that.$vuerify.clear();
                debugger
                switch (that.acontInfo.userType) {
                    case null || '':
                        that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType'])
                        break;
                    case 'CONSUMER_CLIENT': //个人客户
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone'])) {
                            that.submitData();
                        }
                        break;
                    case 'CORPORATE_CLIENTS': //企业客户
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone', 'acontInfo.attachmentUrl'])) {
                            that.submitData();
                        }
                        break;
                    case 'INSTITUTIONAL_INVESTOR': //投资机构/个人
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone', 'acontInfo.attachmentUrl'])) {
                            that.submitData();
                        }
                        break;
                    case 'BANK': //银行
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone', 'acontInfo.logoUrl', 'acontInfo.abbreviation', 'acontInfo.websiteLink', 'acontInfo.remarks'])) {
                            that.submitData();
                        }
                        break;
                    case 'GOVERNMENT_DEPARTMENT': //政府部门
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone'])) {
                            that.submitData();
                        }
                        break;
                    case 'INCUBATOR': //孵化器
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone'])) {
                            that.submitData();
                        }
                        break;
                    case 'FINANCE_LEASING_COMPANY': //融资租赁公司
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone', 'acontInfo.attachmentUrl', 'acontInfo.classify', 'acontInfo.logoUrl', 'acontInfo.remarks'])) {
                          debugger
                            that.submitData();
                        }
                        break;
                    case 'GUARANTEE_COMPANY': //担保公司
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone', 'acontInfo.attachmentUrl', 'acontInfo.logoUrl', 'acontInfo.remarks'])) {
                            that.submitData();
                        }
                        break;
                }
            },
            // 添加账号
            async submitData() {
              const that = this
              debugger
              try{
                if (!that.edit) {
                    const r = await that.$axiosz.post('/backstage/sysUser/manage', that.$qs.stringify(that.acontInfo))
                    if (r.code == 200) {
                            that.$message({
                                type: 'success',
                                message: '添加账号成功!'
                            });
                            // that.getData();
                            that.cancel();
							              that.clearDell();//重置数据
                        } else {
                            that.$alert(r.msg)
                        }
                } else {
                  const res = await that.$axiosz.put('/backstage/sysUser/manage/' + that.usId, that.$qs.stringify(that.acontInfo))
                  if (res.code == 200) {
                            this.$message({
                                type: 'success',
                                message: '编辑账号成功!'
                            });
                            // that.getData();
                            that.cancel();
                        } else {
                            that.$alert(r.msg)
                        }
                }
              }catch(e){
                that.$alert(e.msg || (!that.edit?'添加账号成功':'编辑账号成功'))
              }

            },
        
        cancel() {
            this.$router.back(-1);
        },
        //获取字典
            async getDic() {
                // 分类
                const classifyList = await  this.$axiosz.get('rpc/sysDict/parentId//1069409808416768')
                if(classifyList.code === 200) this.classifyList = classifyList.data || [];
                
                const userTypeAdd = await this.$axiosz.get('backstage/sysDict/isShow/CUSTOMER_TYPE')
                if(userTypeAdd.code === 200) this.userTypeAdd = userTypeAdd.data || [];
                
            }
    }
}
</script>

<style lang="scss" scoped>
.warp{
     height:96%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding-top: 40px;
        .forms{
            max-width: 650px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.singleBtn{
				text-align: center;
			}
			.error{
				// padding-left: 100px;
			}
        }
    }
}
</style>